"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOidcReactApi_dependencyInjection = createOidcReactApi_dependencyInjection;
exports.createReactOidc = createReactOidc;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var oidc_1 = require("../oidc");
var tsafe_1 = require("../vendor/frontend/tsafe");
var tsafe_2 = require("../vendor/frontend/tsafe");
var Deferred_1 = require("../tools/Deferred");
function createOidcReactApi_dependencyInjection(paramsOrGetParams, createOidc) {
    var _this = this;
    var dReadyToCreate = new Deferred_1.Deferred();
    var oidcContext = (0, react_1.createContext)(undefined);
    // NOTE: It can be InitializationError only if autoLogin is true
    var prOidcOrInitializationError = (function () { return __awaiter(_this, void 0, void 0, function () {
        var params, oidc, error_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (function () { return __awaiter(_this, void 0, void 0, function () {
                        var getParams, params_1, params;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(typeof paramsOrGetParams === "function")) return [3 /*break*/, 3];
                                    getParams = paramsOrGetParams;
                                    return [4 /*yield*/, dReadyToCreate.pr];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, getParams()];
                                case 2:
                                    params_1 = _a.sent();
                                    return [2 /*return*/, params_1];
                                case 3:
                                    params = paramsOrGetParams;
                                    return [2 /*return*/, params];
                            }
                        });
                    }); })()];
                case 1:
                    params = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, createOidc(params)];
                case 3:
                    oidc = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    if (!(error_1 instanceof oidc_1.OidcInitializationError)) {
                        throw error_1;
                    }
                    return [2 /*return*/, error_1];
                case 5: return [2 /*return*/, oidc];
            }
        });
    }); })();
    function OidcProvider(props) {
        var fallback = props.fallback, ErrorFallback = props.ErrorFallback, children = props.children;
        var _a = __read((0, react_1.useState)(undefined), 2), oidcOrInitializationError = _a[0], setOidcOrInitializationError = _a[1];
        (0, react_1.useEffect)(function () {
            dReadyToCreate.resolve();
            prOidcOrInitializationError.then(setOidcOrInitializationError);
        }, []);
        if (oidcOrInitializationError === undefined) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: fallback === undefined ? null : fallback });
        }
        if (oidcOrInitializationError instanceof oidc_1.OidcInitializationError) {
            var initializationError = oidcOrInitializationError;
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: ErrorFallback === undefined ? ((0, jsx_runtime_1.jsxs)("h1", { style: { color: "red" }, children: ["An error occurred while initializing the OIDC client:\u00A0", initializationError.message] })) : ((0, jsx_runtime_1.jsx)(ErrorFallback, { initializationError: initializationError })) }));
        }
        var oidc = oidcOrInitializationError;
        return (0, jsx_runtime_1.jsx)(oidcContext.Provider, { value: oidc, children: children });
    }
    function useOidc(params) {
        var assert_params = (params !== null && params !== void 0 ? params : {}).assert;
        var oidc = (0, react_1.useContext)(oidcContext);
        (0, tsafe_1.assert)(oidc !== undefined, "You must use useOidc inside the corresponding OidcProvider");
        check_assertion: {
            if (assert_params === undefined) {
                break check_assertion;
            }
            var getMessage = function (v) {
                return [
                    "There is a logic error in the application.",
                    "If this component is mounted the user is supposed ".concat(v, "."),
                    "An explicit assertion was made in this sense."
                ].join(" ");
            };
            switch (assert_params) {
                case "user logged in":
                    if (!oidc.isUserLoggedIn) {
                        throw new Error(getMessage("to be logged in but currently they arn't"));
                    }
                    break;
                case "user not logged in":
                    if (oidc.isUserLoggedIn) {
                        throw new Error(getMessage("not to be logged in but currently they are"));
                    }
                    break;
                default:
                    (0, tsafe_1.assert)(false);
            }
        }
        var _a = __read((0, react_1.useReducer)(function () { return []; }, []), 2), forceUpdate = _a[1];
        // TODO: Remove in next major version
        (0, react_1.useEffect)(function () {
            if (!oidc.isUserLoggedIn) {
                return;
            }
            var unsubscribe = oidc.subscribeToTokensChange(forceUpdate).unsubscribe;
            return unsubscribe;
        }, [oidc]);
        var refTokensState = (0, react_1.useRef)({
            isConsumerReadingTokens: false,
            tokens: undefined
        });
        var tokensPropertyDescriptorGetter = function () {
            var tokenState = refTokensState.current;
            tokenState.isConsumerReadingTokens = true;
            return tokenState.tokens;
        };
        (0, react_1.useEffect)(function () {
            if (!oidc.isUserLoggedIn) {
                return;
            }
            var updateTokens = function (tokens) {
                if (tokens === refTokensState.current.tokens) {
                    return;
                }
                var tokenState = refTokensState.current;
                tokenState.tokens = tokens;
                if (tokenState.isConsumerReadingTokens) {
                    forceUpdate();
                }
            };
            var isActive = true;
            oidc.getTokens_next().then(function (tokens) {
                if (!isActive) {
                    return;
                }
                updateTokens(tokens);
            });
            var unsubscribe = oidc.subscribeToTokensChange(function (tokens) {
                updateTokens(tokens);
            }).unsubscribe;
            return function () {
                isActive = false;
                unsubscribe();
            };
        }, []);
        var common = {
            params: oidc.params
        };
        if (!oidc.isUserLoggedIn) {
            return (0, tsafe_2.id)(__assign(__assign({}, common), { isUserLoggedIn: false, login: oidc.login, initializationError: oidc.initializationError }));
        }
        var oidcReact = __assign(__assign({}, common), { isUserLoggedIn: true, oidcTokens: oidc.getTokens(), decodedIdToken: oidc.getDecodedIdToken(), tokens: null, logout: oidc.logout, renewTokens: oidc.renewTokens, subscribeToAutoLogoutCountdown: oidc.subscribeToAutoLogoutCountdown, goToAuthServer: oidc.goToAuthServer, isNewBrowserSession: oidc.isNewBrowserSession, backFromAuthServer: oidc.backFromAuthServer });
        Object.defineProperty(oidcReact, "tokens", {
            get: tokensPropertyDescriptorGetter,
            enumerable: true,
            configurable: true
        });
        return oidcReact;
    }
    var prOidc = prOidcOrInitializationError.then(function (oidcOrInitializationError) {
        if (oidcOrInitializationError instanceof oidc_1.OidcInitializationError) {
            return new Promise(function () { });
        }
        var oidc = oidcOrInitializationError;
        return oidc;
    });
    return {
        OidcProvider: OidcProvider,
        // @ts-expect-error: We know what we are doing
        useOidc: useOidc,
        // @ts-expect-error: We know what we are doing
        getOidc: function () { return __awaiter(_this, void 0, void 0, function () {
            var oidc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dReadyToCreate.resolve();
                        return [4 /*yield*/, prOidc];
                    case 1:
                        oidc = _a.sent();
                        if (!oidc.isUserLoggedIn) return [3 /*break*/, 3];
                        return [4 /*yield*/, oidc.getTokens_next()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, oidc];
                }
            });
        }); }
    };
}
/** @see: https://docs.oidc-spa.dev/v/v6/usage#react-api */
function createReactOidc(params) {
    return createOidcReactApi_dependencyInjection(params, oidc_1.createOidc);
}
//# sourceMappingURL=react.js.map